import React, { useState } from "react";

import { DishItem } from "./OrderBodyDishItem";

import "./activeOrder.css";
import { convertDate } from "../../../utils/sort";

export const ActiveOrder = ({
  order,
  handleUpdateOrderAdmin,
  handleUpdateOrderChef,
  handleConfirmOrder,
  handleInactivateOrder
}) => {
  const [isOrderBodyShown, setOrderBodyShown] = useState(false);
  const [isOrderUpdating, setOrderUpdating] = useState(false);

  const [isPrintOrderCardModalShown, setIsPrintOrderCardModalShown] = useState(
    false
  );

  const toggleDropDown = () => {
    if (!isOrderBodyShown) setOrderBodyShown(true);
    if (isOrderBodyShown) setOrderBodyShown(false);
  };

  const handleRefresh = () => {
    setOrderUpdating(true);
    setTimeout(() => {
      setOrderUpdating(false);
    }, 1000);
  };

  const handleAcceptOrder = () => {
    let payload = {
      id: order._id,
      orderStatus: "accepted"
    };
    setOrderUpdating(true);
    setTimeout(() => {
      handleUpdateOrderAdmin(order._id, payload);
      setOrderUpdating(false);
    }, 400);
  };

  const handleUpdateOrderIsPaymentAllowed = () => {
    try {
      let payload = {
        id: order._id,
        orderIsPaymentAllowed: order.orderIsPaymentAllowed ? false : true
      };
      setOrderUpdating(true);
      setTimeout(() => {
        handleUpdateOrderAdmin(order._id, payload);
        setOrderUpdating(false);
      }, 400);
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirmPayment = async () => {
    let payload = {
      id: order._id
    };
    if (!order.orderIsPaid) {
      payload.orderIsPaid = true;
    } else {
      payload.orderIsPaid = false;
    }

    setOrderUpdating(true);
    setTimeout(() => {
      handleUpdateOrderAdmin(order._id, payload);
      setOrderUpdating(false);
    }, 400);
  };

  const handleFulfill = async () => {
    let payload = {
      id: order._id
    };
    if (order.orderStatus !== "fulfilled") {
      payload.orderStatus = "fulfilled";
    } else {
      payload.orderStatus = "accepted";
    }
    setOrderUpdating(true);
    setTimeout(() => {
      handleUpdateOrderAdmin(order._id, payload);
      setOrderUpdating(false);
    }, 400);
  };

  const handleCancel = async () => {
    let payload = {
      id: order._id
    };
    if (order.orderStatus !== "cancelled") {
      payload.orderStatus = "cancelled";
    } else {
      payload.orderStatus = "accepted";
    }
    setOrderUpdating(true);
    setTimeout(() => {
      handleUpdateOrderAdmin(order._id, payload);
      setOrderUpdating(false);
    }, 400);
  };

  const handleCancelPaid = async () => {
    let payload = {
      id: order._id
    };
    if (order.orderStatus !== "cancelled") {
      payload.orderStatus = "cancelled";
    } else {
      payload.orderStatus = "accepted";
    }
    setOrderUpdating(true);
    setTimeout(() => {
      handleUpdateOrderAdmin(order._id, payload);
      setOrderUpdating(false);
    }, 400);
  };

  const handleInactivate = async () => {
    setOrderUpdating(true);
    try {
      await handleInactivateOrder(order._id);
    } catch (err) {
      setOrderUpdating(false);
    }
  };

  // Order switches
  const handleOrderStatusClassSwitch = (status) => {
    switch (status) {
      case "requested":
        return "activeOrderDailymenu--requested";
      case "accepted":
        return "activeOrderDailymenu--accepted";
      case "fulfilled":
        return "activeOrderDailymenu--fulfilled";
      case "cancelled":
        return "activeOrderDailymenu--cancelled";
    }
  };
  const handleOrderStatusTextSwitch = (status) => {
    switch (status) {
      case "requested":
        return "requested";
      case "accepted":
        return "accepted";
      case "fulfilled":
        return "fulfilled";
      case "cancelled":
        return "cancelled";
    }
  };
  const handleOrderTakeTypeSwitch = (takeType) => {
    switch (takeType) {
      case "eatIn":
        return "Eat in";
      case "takeOut":
        return "Take away";
      case "delivery":
        return "Delivery";
    }
  };

  return (
    <>
      <div
        className={`activeOrderDailymenu
                ${handleOrderStatusClassSwitch(order.orderStatus)}
            `}
      >
        <button
          title="refresh order"
          onClick={() => handleRefresh()}
          disabled={isOrderUpdating}
          className={`activeOrderDailymenu__refreshBtn ${
            isOrderUpdating ? "activeOrderDailymenu__refreshBtn--spinner" : ""
          }`}
        >
          <svg
            className="activeOrderDailymenu__refreshBtn__svg"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            fill="var(--btn-border-color-blue)"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3.17 6.706a5 5 0 0 1 7.103-3.16.5.5 0 1 0 .454-.892A6 6 0 1 0 13.455 5.5a.5.5 0 0 0-.91.417 5 5 0 1 1-9.375.789z"
            />
            <path
              fillRule="evenodd"
              d="M8.147.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.707-.708L10.293 3 8.147.854a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </button>
        <div className="activeOrderDailymenu__gistContainer">
          <div className={`activeOrderDailymenu__gistContainer__orderNo`}>
            Order №{order.orderNo}
            {isOrderUpdating ? (
              <div className="updateActiveOrderSpinner"></div>
            ) : null}
            <br />
            <div style={{ fontSize: "medium" }}>
              {handleOrderTakeTypeSwitch(order.orderTakeType)}
            </div>
          </div>
          <button
            className="activeOrderDailymenu__toggleDropdownBtn"
            onClick={() => toggleDropDown()}
          >
            order contents{" "}
            <svg
              className="bi bi-chevron-compact-down"
              width="1em"
              height="1em"
              viewBox="0 0 20 20"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3.553 8.776a.5.5 0 01.67-.223L10 11.44l5.776-2.888a.5.5 0 11.448.894l-6 3a.5.5 0 01-.448 0l-6-3a.5.5 0 01-.223-.67z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          <div
            className={`activeOrderDailymenu__orderbodyContainer ${
              isOrderBodyShown
                ? "activeOrderDailymenu__orderbodyContainer--shown"
                : "activeOrderDailymenu__orderbodyContainer--hidden"
            }`}
          >
            <div className="orderbodyContainer__tableHead">
              <div className="orderbodyContainer__tableHead__dishName">
                Item
              </div>
              <div className="orderbodyContainer__tableHead__dishCounter">
                Amount
              </div>
              <div className="orderbodyContainer__tableHead__dishCost">Sum</div>
            </div>
            {order.orderBody.map((dish, index) => (
              <DishItem dish={dish} index={index} key={dish._id} />
            ))}
            <button
              className="orderbodyContainer__toggleDropdownBtn"
              onClick={() => toggleDropDown()}
            >
              <svg
                className="bi bi-chevron-compact-up"
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M9.776 7.553a.5.5 0 01.448 0l6 3a.5.5 0 11-.448.894L10 8.56l-5.776 2.888a.5.5 0 11-.448-.894l6-3z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div className="activeOrderDailymenu__gistContainer__orderStatus">
            status: {handleOrderStatusTextSwitch(order.orderStatus)}
          </div>
          <div className="activeOrderDailymenu__gistContainer__orderTimeFormatted">
            Requested at {order.orderTimeFormatted.slice(0, 5)}{" "}
            {convertDate(order.orderDateFormatted)}
          </div>
          <div className="activeOrderDailymenu__gistContainer__orderTakeType">
            Order type: {handleOrderTakeTypeSwitch(order.orderTakeType)}
          </div>
          {order.orderTakeType === "delivery" ? (
            <div className="activeOrderDailymenu__gistContainer__orderDeliveryAddress">
              Delivery address: {order.orderDeliveryAddress}
            </div>
          ) : null}
          {order.orderTakeType === "delivery" ? (
            <div className="activeOrderDailymenu__gistContainer__orderDeliveryPrice">
              Delivery price:{" "}
              {order.orderDeliveryPrice
                ? `${order.orderDeliveryPrice}$`
                : "included separetely"}
            </div>
          ) : null}
          <div className="activeOrderDailymenu__gistContainer__orderTakeTime">
            Due time: {order.orderTakeTime}
          </div>
          <div className="activeOrderDailymenu__gistContainer__customerDiv">
            <h4 className="activeOrderDailymenu__gistContainer__customerDiv__heading">
              Client
            </h4>
            <div className="activeOrderDailymenu__gistContainer__customerDiv__isFromRegistered">
              {order.isFromRegistered ? "Registered user" : "Unregistered user"}
            </div>
            <div className="activeOrderDailymenu__gistContainer__customerDiv__customerPhone">
              Phone number: <br />
              +7{order.customerPhone}
            </div>
            <div className="activeOrderDailymenu__gistContainer__customerDiv__customerMail">
              Email: <br />
              {order.customerMail ? order.customerMail : "unavailable"}
            </div>
          </div>
          {order.orderPaymentType === "online" &&
          order.orderTakeType === "delivery" ? (
            <div className="activeOrderDailymenu__gistContainer__orderIsPaymentAllowed">
              Payment allowed: {order.orderIsPaymentAllowed ? "yes" : "no"}
              <input
                type="checkbox"
                disabled={order.orderIsPaid}
                value={order.orderIsPaymentAllowed}
                checked={order.orderIsPaymentAllowed}
                onChange={handleUpdateOrderIsPaymentAllowed}
              />
            </div>
          ) : null}
          <div className="activeOrderDailymenu__gistContainer__orderPaymentType">
            Payment type:{" "}
            {order.orderPaymentType === "onSpot" ? "On spot" : "Online"}
          </div>
          <div className="activeOrderDailymenu__gistContainer__orderIsPaid">
            Payment status: {order.orderIsPaid ? "Paid" : "Not paid"}
          </div>
          <div className="activeOrderDailymenu__gistContainer__orderSum">
            Order sum: {order.orderSum} $
          </div>
        </div>
        <div className="activeOrderDailymenu__controlsBtnContainer">
          <button
            className={`
                        activeOrderDailymenu__controlsBtnContainer__acceptBtn
                        ${
                          order.orderStatus === "accepted"
                            ? "activeOrderDailymenu__controlsBtnContainer__acceptBtn--accepted"
                            : ""
                        }
                    `}
            disabled={
              isOrderUpdating
                ? true
                : order.orderStatus !== "requested"
                ? true
                : false
            }
            onClick={() => handleAcceptOrder()}
          >
            {order.orderStatus === "requested" ? "accept" : "accepted"}
          </button>
          {order.orderPaymentType !== "online" ? (
            <button
              className={`
                        activeOrderDailymenu__controlsBtnContainer__confirmPaymentBtn
                            ${
                              order.orderIsPaid === true
                                ? "activeOrderDailymenu__controlsBtnContainer__confirmPaymentBtn--paid"
                                : ""
                            }
                        `}
              disabled={isOrderUpdating ? true : false}
              onClick={() => handleConfirmPayment()}
            >
              {!order.orderIsPaid ? "confirm payment" : "undo confirm payment"}
            </button>
          ) : null}
          <button
            className={`
                        activeOrderDailymenu__controlsBtnContainer__confirmBtn
                        ${
                          order.orderStatus === "fulfilled"
                            ? "activeOrderDailymenu__controlsBtnContainer__confirmBtn--fulfilled"
                            : ""
                        }
                    `}
            disabled={
              isOrderUpdating || order.orderStatus === "requested"
                ? true
                : !order.orderIsPaid && order.orderStatus !== "fulfilled"
                ? true
                : false
            }
            onClick={() => handleFulfill()}
          >
            {order.orderStatus === "fulfilled" &&
            order.orderStatus !== "accepted"
              ? "undo fulfilled"
              : "fulfilled"}
          </button>
          <button
            className={`
                    activeOrderDailymenu__controlsBtnContainer__cancelBtn
                        ${
                          order.orderStatus === "cancelled"
                            ? "activeOrderDailymenu__controlsBtnContainer__cancelBtn--cancelled"
                            : ""
                        }
                    `}
            disabled={
              isOrderUpdating || order.orderStatus === "requested"
                ? true
                : false
            }
            onClick={
              order.orderPaymentType === "online" && order.orderIsPaid === true
                ? () => handleCancelPaid()
                : () => handleCancel()
            }
          >
            {order.orderStatus === "cancelled"
              ? "restore order"
              : order.orderIsPaid === true
              ? order.orderPaymentType === "online"
                ? "cancel paid order"
                : "cancel paid order"
              : "cancel order"}
          </button>
          {order.orderStatus === "fulfilled" ||
          order.orderStatus === "cancelled" ? (
            <button
              className={`
                                    activeOrderDailymenu__controlsBtnContainer__inactivateBtn
                                `}
              disabled={isOrderUpdating ? true : false}
              onClick={() => handleInactivate()}
            >
              move to history
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
};
